import { render, staticRenderFns } from "./EstateAdministrationCostCalculatorFooter.vue?vue&type=template&id=016d52a0&scoped=true"
import script from "./EstateAdministrationCostCalculatorFooter.vue?vue&type=script&lang=js"
export * from "./EstateAdministrationCostCalculatorFooter.vue?vue&type=script&lang=js"
import style0 from "./EstateAdministrationCostCalculatorFooter.vue?vue&type=style&index=0&id=016d52a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d52a0",
  null
  
)

export default component.exports